import React, { useState, useEffect } from "react";
import { useStore } from 'react-context-hook'
//import { StatusBar, View, Text } from "react-native";
//import { Container, Header, Title, Left, Icon, Right, Button, Body, Content,Text, Card, CardItem, CardSwiper } from "native-base";
import { Layouts } from '../../utils';
import Styles from '../../Styles';
import { StyleSheet, ImageBackground, Image, View, ScrollView, ViewPagerAndroid } from "react-native";
import { Container, H1,  Header,  Title,  Button,  Card,  CardItem,  Icon,  Thumbnail,  Text,  Left,  Right,  Body, Footer, Grid, Col, Row } from "native-base";
import * as DashboardData from '../../utils/TestData/DashboardData';
import Constants from 'expo-constants';
import { Assets } from 'expo-asset'

export default function DashboardMain({ navigation }) {

    Layouts.StackNavigationHeader({navigation});

    const [platform] = useStore('platform')
    const [displayDesktop] = useStore('displayDesktop')

    const [dashStats, setDashStats] = useState({data: []});
    const [query, setQuery] = useState(DashboardData.dashStats);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const test = DashboardData.dashStats

    const onProfileCardImagePress = () => {
        alert('profile card')
    }

  const styles = StyleSheet.create({
    container: {
      backgroundColor: "#FFF",
      textAlign: "center",
    }
  });  

    return (
      
      <Container style={styles.container}>

        {/* TODO: move styling to master  */}
        <ImageBackground source={global.BackgroundImage} style={displayDesktop ? Styles.Typography.generalAppContainer.desktop : Styles.Typography.generalAppContainer.mobile}>

          <ScrollView>
            {/* Version Number For QA */}

            <View style={Styles.Typography.generalFloatingHeader.container}>
                <Text style={Styles.Typography.generalFloatingHeader.text}>
                    Version: {Constants.manifest.version}
                </Text>
            </View>

            {/* Stats Display */}
            <ScrollView
            style={{ }}
            contentContainerStyle={{ flexGrow:1, justifyContent:"center" }}
            horizontal
            showsHorizontalScrollIndicator={true}
            //onScroll={event => this.handleScroll(event)}
            >
            {
              DashboardData.dashStats.map(data => 
                <Card border style={displayDesktop ? Styles.Typography.dashStatsCardContainer.desktop : Styles.Typography.dashStatsCardContainer.mobile}>

                  <CardItem header style= {displayDesktop ? Styles.Typography.dashStatsCardHeaderContainer.desktop : Styles.Typography.dashStatsCardHeaderContainer.mobile}>
                    <Text style={Styles.Typography.dashStatsCardHeaderText}>{data.Stat}</Text>
                  </CardItem>

                  <CardItem>
                    <Body style={Styles.Typography.dashStatsCardBody}>
                      
                      <View style={Styles.Typography.dashStatsDataContainer}>
                        <Text style={Styles.Typography.dashStatsTextHeader}>Last Login</Text>
                        <Text style={Styles.Typography.dashStatsText}>{data.LastLogin}</Text>
                      </View>

                      <View style={Styles.Typography.dashStatIconContainer}>
                        {data.IconPath == 'heart' ? 
                          (
                            <Icon name={'ios-heart'} style={Styles.Typography.dashStatIconImage, { color: Styles.Colors.colorPalette.mainColor }} />
                          ) : (
                            <Icon name={'eye'} type='Entypo' style={Styles.Typography.dashStatIconImage, { color: Styles.Colors.colorPalette.Dark}} />
                          )}
                      </View>

                      {/* <Image source={require('../../assets/ViewedYou.png')} 
                          style={{ width: 100, height: 100, overflow:'visible' }}
                          /> */}

                      <View style={Styles.Typography.dashStatsDataContainer}>
                        <Text style={Styles.Typography.dashStatsTextHeader}>This Week</Text>
                        <Text style={Styles.Typography.dashStatsText}>{data.ThisWeek}</Text>
                      </View>

                    </Body>
                  </CardItem>
                </Card>
              )
            } 

{/* Viewing history */}
            <Card style={displayDesktop ? Styles.Typography.dashStatsCardContainer.desktop : Styles.Typography.dashStatsCardContainer.mobile}>

              <CardItem header style= {displayDesktop ? Styles.Typography.dashStatsCardHeaderContainer.desktop : Styles.Typography.dashStatsCardHeaderContainer.mobile}>
                <Text style={Styles.Typography.dashStatsCardHeaderText}>Viewing History</Text>
              </CardItem>

              <ScrollView>
                {
                  DashboardData.viewingHistoryData.map(viewed => 

                    <CardItem style={{flex:1}}>

                        <Left style={{flex:1}}>
                          <Thumbnail small source={viewed.profilePic} />
                        </Left>

                        <Body style={Styles.Typography.dashViewingHistoryBody, {justifyContent:'center'}}>
                          <Text style={Styles.Typography.dashViewingHistoryText} numberOfLines={1}>{viewed.fullName}</Text>
                          <Text style={Styles.Typography.dashViewingHistoryText}>{viewed.gender}</Text>
                          <Text style={Styles.Typography.dashViewingHistoryText}>Age: {viewed.age}</Text>
                        </Body>

                        <Right style={{flex:1}}>
                          <Styles.Components.Bookmark bookmarked={viewed.bookmarked} />
                        </Right>

                    </CardItem>    

                  )
                }
              </ScrollView>

            </Card>
            
          </ScrollView>

    {/* Profiles Display */}

            <View style={Styles.Typography.generalFloatingHeader.container}>
                <Text style={Styles.Typography.generalFloatingHeader.text}>
                    Your Top Matches
                </Text>
            </View>

            {/* <ScrollView 
                style={{  }}
                contentContainerStyle={{ flexGrow:1, justifyContent:"center" }}
                horizontal
            >
                {DashboardData.matchData.map(card =>
                    <Styles.Components.ProfileCard 
                        fullName={card.fullName}
                        image={card.image}
                        percentageMatch={card.percentageMatch}
                        gender={card.gender}
                        age={card.age}
                        favored={card.favored}
                    />
                )}
            </ScrollView> */}

            <View
                style={Styles.Typography.dashboardCards.cardContainer}
            >
                {DashboardData.matchData.map(card =>
                    <Styles.Components.ProfileCardSlim 
                        displayDesktop={displayDesktop}
                        onPress={onProfileCardImagePress}
                        fullName={card.fullName}
                        image={card.image}
                        percentageMatch={card.percentageMatch}
                        gender={card.gender}
                        age={card.age}
                        favored={card.favored}
                    />
                )}
            </View>

            <View style={Styles.Typography.generalFloatingHeader.container}>
                <Text style={Styles.Typography.generalFloatingHeader.text}>
                    Other Matches For You
                </Text>
            </View>

                <View
                    style={Styles.Typography.dashboardCards.cardContainer}
                >
                    {DashboardData.matchDataOther.map(card =>
                        <Styles.Components.ProfileCardSlim 
                            displayDesktop={displayDesktop}
                            onPress={onProfileCardImagePress}
                            fullName={card.fullName}
                            image={card.image}
                            percentageMatch={card.percentageMatch}
                            gender={card.gender}
                            age={card.age}
                            favored={card.favored}
                        />
                    )}
                </View>

            </ScrollView>

      </ImageBackground>

    </Container>

    );

  }
 
